// Session lifecycle for the current user.
export const BOOTSTRAP_SESSION = "BOOTSTRAP_SESSION"; // dispatched once at app mount
export const FETCH_ME          = "FETCH_ME";          // dispatched after successful login
export const ME_REQUEST        = "ME_REQUEST";        // saga-internal: status -> loading
export const ME_SUCCESS        = "ME_SUCCESS";        // payload: { user, permissions }
export const ME_FAILURE        = "ME_FAILURE";        // payload: error message
export const SESSION_ANONYMOUS = "SESSION_ANONYMOUS"; // no token / 401 from /auth/me
export const CLEAR_PROFILE     = "CLEAR_PROFILE";     // logout
